import React from 'react';
import MostrarServicios from './MostrarServicios';
import ContenedorAnimacion from './ContenedorAnimacion';
import ImageMarquee from './ImageMarquee';

import partner00 from '../assets/images/partners/partners_00_500.png';
import partner01 from '../assets/images/partners/partners_01_500.png';
import partner02 from '../assets/images/partners/partners_02_500.png';
import partner03 from '../assets/images/partners/partners_03_500.png';
import partner04 from '../assets/images/partners/partners_04_500.png';
import partner05 from '../assets/images/partners/partners_05_500.png';
import partner06 from '../assets/images/partners/partners_06_500.png';
import partner07 from '../assets/images/partners/partners_07_500.png';
import partner08 from '../assets/images/partners/partners_08_500.png';
import partner09 from '../assets/images/partners/partners_09_500.png';
import partner10 from '../assets/images/partners/partners_10_500.png';
import partner11 from '../assets/images/partners/partners_11_500.png';
import partner12 from '../assets/images/partners/partners_12_500.png';
import partner13 from '../assets/images/partners/partners_13_500.png';
import partner14 from '../assets/images/partners/partners_14_500.png';
import partner15 from '../assets/images/partners/partners_15_500.png';
import partner16 from '../assets/images/partners/partners_16_500_horizontal.png';


import { Link } from 'wouter';
import SearchIcon from '@mui/icons-material/Search';


const Servicios: React.FC<{ id: string }> = ({ id }) => {
    const PartnersImages = [
        {image:partner00, link:'https://www.cruzazulsalud.com.ar/'},
    //    {image:partner01, link:'https://www.mutualportuaria.com.ar/'},
    //    {image: partner02, link: 'https://www.pluspagos.com/'},
        {image: partner03, link: 'https://www.mercadopago.com.ar/'},
        {image: partner04, link: 'https://www.sancorseguros.com.ar/'},
        {image: partner05, link: 'https://europtica.com.ar/'},
        {image: partner06, link: 'https://www.ecco.com.ar/'},
        {image: partner07, link: 'https://inmunitas.com.ar/web/'},
        {image: partner08, link: 'https://llamandoaldoctor.com/'},
        {image: partner09, link: 'https://dentaltotal.com.ar/'},
    //    {image:partner10, link:'https://cooportuaria.com/ccrep/'},
        {image:partner11, link:'https://www.copetoserviciossociales.com/'},
        {image:partner12, link:'https://imfonline.com.ar/'},
        {image:partner13, link:'http://espalab.com.ar/#!/-bienvenido-2/'},
        {image:partner14, link:'https://www.mapfre.com.ar/'},
        {image:partner15, link:'https://www.mawdy.com.ar/'},
        {image:partner16, link:'https://www.clinicadeojosrosario.com/home'}

    ];

    return (
        <section id={id} className="bg-white pt-[60px] min-h-screen">
            <div className="pt-8 pb-4 px-4 mx-auto max-w-screen-2xl text-center">
                <ContenedorAnimacion animation='slideInRight' duration={800} delay={1} className="">
                    <div className="mx-auto mb-6 max-w-screen-2xl">
                        <h2 className="font-metropolis mb-4 text-4xl tracking-tight font-regular text-gray-900 ">Servicios</h2>
                        <h3 className="font-metropolis font-regular text-gray-600 sm:text-xl ">Explorá nuestra gama de soluciones diseñadas para brindarte tranquilidad y seguridad.</h3>
                        <Link className="flex justify-center mt-4" to="/Buscador">
                                <button className="vp-btn-azul shadow-md shadow-vp-gris"><SearchIcon />Buscador de Servicios</button>
                        </Link>
                    </div> 
                </ContenedorAnimacion>
            </div>
            <div className="p-2 flex flex-col items-center xs:items-evenly">
                <MostrarServicios />
                <div className="flex flex-col mt-8 w-[90%] justify-center items-center">
                    <h2 className="font-metropolis text-4xl tracking-tight font-regular text-gray-900 ">Conocé a nuestros Partners</h2>
                    <ImageMarquee images={PartnersImages} speed={60} />
                </div>
            </div>

        </section>
    );
};

export default Servicios;